export default "__VITE_ASSET__DNixLaFV__"